import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getWord, updateWord } from '../../../store/actions';
import Input from "@material-ui/core/Input";
import Button from "@material-ui/core/Button";
import authService from '../../../../components/api-authorization/AuthorizeService'

const ariaLabel = { 'aria-label': 'description' };

class ClassTest extends Component {

    state = {
        messageTest: 'yess'
    }

    componentDidMount() {
        /*this.setState({ messageTest: 'helllllo boy' });*/

        //this.props.getWord();

    }

    InputValueChange = e => {

        this.props.updateWord(e.target.value);
    }

    handleClick = () => {
        this.LoginTest()
    }

    async LoginTest() {

        let response = await fetch('api/auth/Login/', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                Username: 'shayflan1@outlook.com',
                Password: 'HelloWorld123#',
                RememberMe: false
            })
        })
            .then(res => res.json())
            .catch();

        const returnUrl = '/';
        const state = { returnUrl };
        const result = await authService.signIn(state);

        alert(result.status);
    }

    checkToken = async () => {
        const token = await authService.getAccessToken();       
        alert(token);
    }



    handleAuthClick = () => {
        this.AuthTest()
    }

    async AuthTest() {

        const token = await authService.getAccessToken();



        let response = await fetch('api/auth/authtest/', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}` 
            },
            body: JSON.stringify({
                Username: 'shayflan1@outlook.com',
                Password: 'HelloWorld123#',
                RememberMe: false
            })
        })
            .then(res => res.json())
            .catch();

    }


    getuserclick = () => {
        console.log(this.props.user);
    }

    render() {
        return (<div>
            <h1>
                {this.props.wordToDisplay}

            </h1>
            <Input value={this.props.wordToDisplay} inputProps={ariaLabel} onChange={this.InputValueChange} />
            <Button onClick={this.handleClick} color="primary">
                Click Me
                </Button>

            <Button onClick={this.checkToken} variant="contained" color="success">
                Token
                </Button>

            <Button onClick={this.handleAuthClick} variant="contained" color="success">
                Auth?
                </Button>

            <Button onClick={this.getuserclick} variant="contained" color="success">
                user
                </Button>
        </div>)
    };
}

const mapStateToProps = state => {
    return {
        wordToDisplay: state.userDetailsTest.word,
        user: state.userReducer.user
    };
};

/*export default ClassTest;*/

export default connect(mapStateToProps, { getWord, updateWord })(ClassTest);
